


import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../components/shared/Button";
import { Link, useNavigate } from "react-router-dom";
import loginTruck from "../../images/img/login-truck.jpg";
import InputText from "../../components/shared/input/new/InputText";
import InputSelect from "../../components/shared/input/new/InputSelect";
import InputMail from "../../components/shared/input/new/InputMail";
import InputPassword from "../../components/shared/input/special/InputPassword";
import { sendMailAdresForVerification, setKayitData, showRegisterModal, updateFirmaType, updateFromCityList, updateToCityList } from "../../features/register/registerSlice";
import { handleActiveSelect } from "../../features/layout/layoutSlice";
import InformationText from "../../components/registerSections/InformationText";
import RegisterModalLayout from "../../layouts/RegisterModalLayout";
import ReCAPTCHA from "react-google-recaptcha";
import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
import InputPhoneFormat from "../../components/shared/input/new/InputPhoneFormat";

import appStore from "../../images/img/app-store.png"
import playStore from "../../images/img/play-store.png"

import appStoreSm from "../../images/img/app-store-sm.png"
import playStoreSm from "../../images/img/play-store-sm.png"
import useWindowDimensions from "../../hooks/useWindowSize";
import InputSelectCityMultiple from "../../components/shared/input/new/InputSelectCityMulti";
import locationCityList from "../../utils/locationData/locationCityOptions";
import InputTextarea from "../../components/shared/input/new/InputTextarea";


const Container = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  .login-container {
    height: 100%;
    width: 100%;
    display: flex;

    @media (max-width: 992px) {
      flex-direction: column;
    }

    .left {
      height: 100vh;
      width: 50%;
      @media (max-width: 992px) {
        display: none;
      }
      .imageBox {
        height: 100%;
        width: 100%;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
    }

    .right {
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100vh;
      max-height: 100vh;
      overflow: auto;
      padding-bottom: 60px;

      @media (max-width: 992px) {
        width: 100%;
      }

      h1 {
        margin-block: 30px;
        font-size: 18px;
        font-weight: 600;
        line-height: 16px;
      }

      .type-container{
        display: flex;
        position: relative;
        border: 2px solid var(--color-main);
        border-radius: 14px;
        /* padding: 3px; */

        .type-item{
          width: 160px;
          height: 40px;
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: .8s;
          color: ${({theme}) => theme.mainTextColor};
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);

        }

        .slider{
          position: absolute;
          /* left: ${({typeStatus}) => typeStatus === 1 && 0};
          right: ${({typeStatus}) => typeStatus === 2 && 0}; */
          border-radius: 10px;
          width: 160px;
          height: 40px;
          background-color: var(--color-main);
          z-index: -1;
          transition: .5s;
          transform: translateX(100%);
          transform: ${({typeStatus}) => typeStatus === 2 ? "translateX(100%)" : "translateX(0)"};

        }

        .type-item-active{
          color: #fff;
        }
      }

      .mobile-navigate-container{
        width: auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 40px;

        @media (max-width: 1200px) {
          width: 70%;
        }
        .desc{
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
          color: ${({theme}) => theme.mainTextColor};
          text-align: center;
        }

        .link-container{
          display: flex;
          justify-content: center;
          gap: 15px;
          padding: 0 10px;
          img{

            @media (max-width: 600px) {
             width: 180px;
            }
          }
        }
      }


      .form {
        width: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
        & > div {
          margin-block: 15px;
        }
        @media (max-width: 1200px) {
          width: 90%;
        }

        @media (max-width: 992px) {
          width: calc(80% - 40px);
        }

        @media (max-width: 692px) {
          width: calc(100% - 40px);
        }

        .input-grp{
          width: 100%;
        }
      }


      .info{
        display: block;
        font-size: 12px;
        margin-top: 3px;
      }

      .button-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        width: 100%;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
          border-radius: 5px;
          height: 40px;
          width: 100%;
          background-color: var(--color-main);
          font-family: Raleway;
          font-size: 14px;
          font-weight: 500;
          line-height: 16px;
          color: #fff;
        }

        .login-text{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);

          .link{
            color: var(--color-main);
            text-align: center;
          }
        }
      }
    }
    .message-container{
      font-size: var(--font-size-sm);
      color: var(--color-main);
    }
  }
  .error{
        font-size: 12px;
        color: var(--color-main);
        font-weight: var(--font-weight-lg);
      }

  .control{
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;

    
  }
`;

const typeOptions = [
  {
    id: 1,
    text: "Yük Verenim"
  },
  {
    id: 2,
    text: "Yük Taşıyıcıyım"
  }
]

const companyOptions = [
  {
    value:1, 
    text: "Dijital Lojistikçi",
  },
  {
    value:2, 
    text: "Kooperatif",
  },
  // {
  //   value:3, 
  //   text: "Yükveren",
  // },

]

const RegisterNew = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [typeStatus, setTypeStatus] = useState(1)

  const {kayitData, checkInformationText, isLoadingMailVerification, registerErrorMessage, registerVerificationStatus} = useSelector(state => state.register)
  const {yetkiliUsername, yetkiliMail, yetkiliPhoneNumber, vergiNo, firmaName, password, passwordAgain, vehicleVolume, userDesc} = kayitData
  const {acikRizaMetni, aydinlatmaMetni, uyelikSozlesmesi} = checkInformationText
  const [firmaType, setFirmaType] = useState({
    value: "",
    text: ""
  })
  const {windowDimensions} = useWindowDimensions()

  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isShowPasswordAgain, setIsShowPasswordAgain] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false)
  const [recaptchaVerified, setRecaptchaVerified] = useState(false);
  const recaptchaRef = useRef();
  const [passwordControl, setPasswordControl] = useState("")
  const [phoneValue, setPhoneValue] = useState("")

  const [fromCityList, setFromCityList] = useState([])
  const [toCityList, setToCityList] = useState([])


  const handleChange = ({e, type}) => {
    if(type === "number"){
      dispatch(setKayitData({[e.target.name]: e.target.value.replace(/[^0-9]/g, '')}))
    }
    else{
      dispatch(setKayitData({[e.target.name]: e.target.value}))
    }
  };

  useEffect(() => {
    dispatch(updateFirmaType(firmaType))
  },[firmaType])

  useEffect(() => {
    dispatch(updateFromCityList(fromCityList))
  }, [fromCityList])

  useEffect(() => {
    dispatch(updateToCityList(toCityList))
  }, [toCityList])

  useEffect(() => {
    dispatch(setKayitData({yetkiliPhoneNumber: phoneValue}))
  }, [phoneValue])


  const handleRegister = (e) => {
    e.preventDefault()

    if(!registerVerificationStatus){
      setIsSubmit(true)

        if(!passwordControl && acikRizaMetni && aydinlatmaMetni && uyelikSozlesmesi && yetkiliUsername && yetkiliMail && yetkiliPhoneNumber && vergiNo && firmaName && firmaType?.value && password && passwordAgain && parseInt(vehicleVolume) > 0 && fromCityList.length > 0 && toCityList.length > 0){
        // if(recaptchaVerified && acikRizaMetni && aydinlatmaMetni && uyelikSozlesmesi && yetkiliUsername && yetkiliMail && yetkiliPhoneNumber && vergiNo && firmaName && firmaType?.value && password && passwordAgain){
          dispatch(sendMailAdresForVerification({email: kayitData.yetkiliMail, phoneNumber: yetkiliPhoneNumber?.slice(2), taxNo: vergiNo}))
        }
    }

    else{
      dispatch(showRegisterModal("verificationCode"))
    }
  }

  useEffect(() => {


    const hasMinLength = password.length >= 8;
    const hasUppercase = /[A-ZÇĞİÖŞÜ]/.test(password);
    const hasLowercase = /[a-zçğıöşü]/.test(password);
    const hasDigit = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^*(),.?\"{}|€+\-\/\[\]=£~¨]/.test(password);


  if (!password || !hasMinLength || !hasUppercase || !hasLowercase || !hasDigit || !hasSpecialChar || (password !== passwordAgain)){
    setPasswordControl("Şifrelerin aynı olması gerekmektedir, en az 8 karakter olmalı, büyük-küçük harf, rakam ve özel karakter içermelidir.")
  }
  else{
    setPasswordControl("")
  }

    // if(password !== passwordAgain){
    //   setPasswordControl("Şifrelerin aynı olması gerekmektedir.")
    // }else{
    //   setPasswordControl("")
    // }
  },[kayitData.password, kayitData.passwordAgain])



  const handleRecaptchaChange = (token) => {
    if (token) {
      setRecaptchaVerified(true);
    } else {
      setRecaptchaVerified(false);
    }
  };

  const handleTypeStatus = (id) => {
    setTypeStatus(id)

    // if(isMobile && id === 2){
    //   const link = document.createElement('a');
    //   link.href = `https://kamyoon.com/app-link`;
    //   document.body.appendChild(link)
    //   link.click();
    //   document.body.removeChild(link)
    // }
  }

  return (
    <Container onClick={() => dispatch(handleActiveSelect(null))} typeStatus={typeStatus}>
      <RegisterModalLayout/>
      <div className="login-container">
        <div className="left">
          <div className="imageBox">
            <img src={loginTruck} alt="login-truck" />
          </div>
        </div>

        <div className="right">
          <h1>Kamyoon'a Kayıt Olun</h1>
          <div className="type-container">
            {
              typeOptions.map(item => (
                <div className={item.id === typeStatus ? "type-item type-item-active" : "type-item"} onClick={() => handleTypeStatus(item.id)} key={item.id}>{item.text}</div>
              ))
            }
            <div className={`slider`} ></div>
          </div>
          {
            typeStatus === 1 ?
          <form className="form" onSubmit={handleRegister}>
            <div className="input-grp">
              <InputText data={yetkiliUsername} setData={(e) => handleChange({e, type: ""})} labelText="Yetkili Adı Soyadı" inputWidth={"100%"} name={"yetkiliUsername"}/>
              {isSubmit && !yetkiliUsername &&
                <span className="error">Yetkili adı ve soyadını giriniz.</span>
              }
            </div>
            
            <div className="input-grp">
              <InputMail data={yetkiliMail} setData={(e) => handleChange({e, type: ""})} labelText="Yetkili Mail Adresi" inputWidth={"100%"} name={"yetkiliMail"}/>
              {isSubmit && !yetkiliMail &&
                <span className="error">Yetkili mailini giriniz.</span>
              }
            </div>
            
            <div className="input-grp">
              {/* <InputText data={kayitData.yetkiliPhoneNumber} setData={(e) => handleChange({e, type: "number"})} labelText="Yetkili Telefonu" inputWidth={"500px"} name={"yetkiliPhoneNumber"}/> */}
              <InputPhoneFormat data={phoneValue} setData={setPhoneValue} labelText="Yetkili Telefonu" inputWidth={"100%"} name={"yetkiliPhoneNumber"}/>
              {isSubmit && !kayitData.yetkiliPhoneNumber &&
                <span className="error">Yetkili telefon numarasını giriniz.</span>
              }
            </div>
            
            <div className="input-grp">
              <InputText max={11} data={vergiNo} setData={(e) => handleChange({e, type: "number"})} labelText="Firma/Koop. Vergi No" inputWidth={"100%"} name={"vergiNo"}/>
              {isSubmit && !vergiNo &&
                <span className="error">Vergi numarasını giriniz.</span>
              }
            </div>
            
            <div className="input-grp">
              <InputText auto={"off"} data={firmaName} setData={(e) => handleChange({e, type: ""})} labelText="Firma/Koop. Adı/Ünvanı" inputWidth={"100%"} name={"firmaName"}/>
              {isSubmit && !firmaName &&
                <span className="error">Firma adını giriniz.</span>
              }
            </div>

            <div className="input-grp">
              <InputPassword auto="new-password" data={password} setData={(e) => handleChange({e, type: ""})} labelText="Şifre" inputWidth={"100%"} name={"password"} isShow={isShowPassword} setIsShow={() => setIsShowPassword(!isShowPassword)}/>
              <span className="info">(Şifreniz minimum 8 karakter olmalıdır.)</span>
              {isSubmit && !password &&
                <span className="error">Şifre giriniz.</span>
              }
            </div>
            
            <div className="input-grp">
              <InputPassword data={passwordAgain} setData={(e) => handleChange({e, type: ""})} labelText="Şifre Tekrarı" inputWidth={"100%"} name={"passwordAgain"} isShow={isShowPasswordAgain} setIsShow={() => setIsShowPasswordAgain(!isShowPasswordAgain)}/>
              {isSubmit && !passwordAgain &&
                <span className="error">Şifrenizi tekrar giriniz.</span>
              }
              {passwordControl && isSubmit && 
                <span className="error">{passwordControl}</span>
              }
            </div>
            
            
            <div className="input-grp">
              <InputSelect data={firmaType.text} setData={setFirmaType} initialOptions={companyOptions} labelText={"Firma Türü"} inputWidth={"100%"} name={"firmaType"}/>
              {isSubmit && !firmaType.text &&
                <span className="error">Firma tipini seçiniz.</span>
              }
            </div>

            <div className="input-grp">
              <InputSelectCityMultiple data={fromCityList} setData={setFromCityList} labelText={"Yük Çıkış İli (Genel)"} initialOptions={locationCityList} inputWidth={"100%"} name={"fromCityList"}/>
              {isSubmit && fromCityList.length < 1 &&
                <span className="error">En az bir adet Yük çıkış ili Seçiniz.</span>
              }
            </div>

            <div className="input-grp">
                <InputSelectCityMultiple data={toCityList} setData={setToCityList} labelText={"Yük Varış İli (Genel)"} initialOptions={locationCityList} inputWidth={"100%"} name={"toCityList"}/>
              {isSubmit && toCityList.length < 1 &&
                <span className="error">En az bir adet Yük varış ili Seçiniz.</span>
              }
            </div>

            <div className="input-grp">
              <InputText max={11} data={vehicleVolume} setData={(e) => handleChange({e, type: "number"})} labelText="Aylık Araç Hacmi" inputWidth={"100%"} name={"vehicleVolume"}/>
              {isSubmit && !vehicleVolume &&
                <span className="error">Aylık ortalama araç hacmini giriniz.</span>
              }
            </div>

            <div className="input-grp">
              <InputTextarea max={11} data={userDesc} setData={(e) => handleChange({e, type: ""})} labelText="Uygulamadan Beklentiniz" inputWidth={"100%"} name={"userDesc"}/>
              {/* {isSubmit && !userDesc &&
                <span className="error">Aylık ortalama araç hacmini giriniz.</span>
              } */}
            </div>
           
            <InformationText isSubmit={isSubmit}/>

            <div className="control">
              {/* <ReCAPTCHA
                className="captcha"
                sitekey="6LfeAekpAAAAAP8dWHCjB0V6RGYhS01l7-laaJQd"
                onChange={handleRecaptchaChange}
                ref={recaptchaRef}
              /> */}
              {
                isSubmit && !recaptchaVerified &&
                <span className="error">
                  Kayıt olmak için bu alanı işaretleyiniz.
                </span>
              }
              {
                registerErrorMessage &&
                <span className="error">
                  {registerErrorMessage}
                </span>
              }
              {
                
              }
            </div>

            <div className="button-container">
              <button type="submit">{isLoadingMailVerification ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : registerVerificationStatus ? "Kodu Gir" : "Kayıt Ol"}</button>

              <div className="login-text">Hesabın mı var? <Link className="link" to={"/giris-yap"}>Giriş Yap</Link></div>
            </div>
          </form>
          : 
          <div className="mobile-navigate-container">
            <p className="desc">Taşıyıcılar için özel olarak geliştirilmiş Kamyoon uygulamamızı hemen indirin.</p>
            <div className="link-container">
                <a href="https://apps.apple.com/tr/app/kamyoon/id1635928965?l=tr" target="_blank" rel="noreferrer">
                  <img src={windowDimensions.width < 1050 ? appStoreSm : appStore} alt="" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.egeyurt.talha.egeyurtasistan&hl=tr" target="_blank" rel="noreferrer">
                  <img src={windowDimensions.width < 1050 ? playStoreSm : playStore} alt="" />
                </a>
            </div>
          </div>
        }
        </div>
      </div>
    </Container>
  );
};

export default RegisterNew;